"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function FormActions(_ref) {
  var id = _ref.id,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'submit' : _ref$type,
    _ref$mainAction = _ref.mainAction,
    mainAction = _ref$mainAction === void 0 ? (0, _core.translate)(id ? 'buttons.update' : 'buttons.add') : _ref$mainAction,
    _ref$cancelAction = _ref.cancelAction,
    cancelAction = _ref$cancelAction === void 0 ? (0, _core.translate)('buttons.cancel') : _ref$cancelAction,
    disabled = _ref.disabled,
    _ref$mt = _ref.mt,
    mt = _ref$mt === void 0 ? 2 : _ref$mt,
    onClick = _ref.onClick,
    onCancel = _ref.onCancel;
  var history = (0, _reactRouterDom.useHistory)();
  var isXs = (0, _material.useMediaQuery)(function (theme) {
    return theme.breakpoints.down('sm');
  });
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-start",
    spacing: 1,
    direction: "row-reverse",
    sx: {
      mt: mt
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    type: type,
    variant: "contained",
    color: "primary",
    size: "large",
    fullWidth: isXs,
    disabled: disabled,
    onClick: onClick
  }, mainAction)), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    variant: "text",
    color: "inherit",
    size: "large",
    onClick: onCancel !== null && onCancel !== void 0 ? onCancel : history.goBack,
    fullWidth: isXs
  }, cancelAction))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(FormActions);